import { z } from 'my-zod'

export const FuelLevelEnum = z.enum(['1/6', '2/6', '1/2', '4/6', '5/6', 'Full'])

export type FuelLevelType = z.infer<typeof FuelLevelEnum>

export const FuelLevelTypeOptions = Object.values(FuelLevelEnum.Enum)

export const FuelLevelTypes = FuelLevelEnum.Enum
